import apiClient from './client';

const API_BASE = (import.meta.env.VITE_API_URL as string) || '';

export interface OrgMediaUploadResponse {
  /** Object key inside the bucket, `{org_id}/media/{uuid}_{name}`. */
  key: string;
  /** The application route the document references, `/api/orgs/{slug}/media/{key}`. */
  url: string;
}

/** Image types the media endpoint accepts. Mirrors `routers/media.py`. */
export const ORG_MEDIA_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'];

/**
 * Upload an image for use inside rich text of the organisation (spec 049).
 * Creator role or above. The returned `url` is what the editor stores as `src`.
 */
export async function uploadOrgMedia(
  orgSlug: string,
  file: File,
  onProgress?: (percent: number) => void,
): Promise<OrgMediaUploadResponse> {
  const form = new FormData();
  form.append('file', file);
  // No explicit Content-Type: axios sets the multipart boundary itself.
  const { data } = await apiClient.post<OrgMediaUploadResponse>(
    `/api/orgs/${orgSlug}/media/`,
    form,
    onProgress
      ? {
          onUploadProgress: (e) => {
            if (e.total) onProgress(Math.round((e.loaded / e.total) * 100));
          },
        }
      : undefined,
  );
  return data;
}

/** Absolute URL for a media route when the API lives on another origin (dev only). */
export function resolveMediaUrl(src: string): string {
  return API_BASE && src.startsWith('/api/') ? `${API_BASE}${src}` : src;
}
